export const mergeResponse = (channel, youtube) => ({
  ...channel,
  ..._.omit(youtube, 'id', 'title', 'description'),
});
